import Selection from "../../ui/Selection/Selection";
import Pagination from "../Pagination/Pagination";
import './PaginationWrapper.css';

export default function PaginationWrapper({ pageCount, onPageChange, forcePage, limits, limit, onChangeLimit }) {
    return (
        <div className="pagination_wrapper">
            <Pagination
                pageCount={pageCount}
                onPageChange={onPageChange}
                forcePage={forcePage}
            />

            <Selection
                className={'mini'}
                options={limits.map((val) => ({ value: val, label: val }))}
                value={{ value: limit, label: limit }}
                placeholder={'Кількість позицій'}
                onChange={(option) => onChangeLimit(Number(option.value))}
                menuPlacement={'top'}
            />
        </div>
    )
}
